import { Component, inject, ViewChild } from '@angular/core';
import { faTimes, faPlus, faEdit, faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import * as bs from 'bootstrap';
import { ToastrService } from 'ngx-toastr';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { TasksService } from 'src/app/services/tasks.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-holidays',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Tareas y técnicos</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tasks [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Días no laborales</h2>
          </div>
        </div>
        <div class="d-flex">
          <div>
            <button class="btn btn-zazz-dark"  (click)="addHoliday()">
              <fa-icon [icon]="faPlus" class="me-2"></fa-icon>
              Agregar día no laboral
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let holiday of holidays">
                  <td>{{holiday.holiday}}</td>
                  <td>{{holiday.created_at}}</td>
                  <td>
                    <button class="btn btn-outline-danger btn-sm rounded-3"  (click)="deleteHoliday(holiday)">
                      <fa-icon [icon]="faTimes" class="me-2"></fa-icon>
                      Eliminar
                    </button>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
          <div class="list-group-item text-center pt-3" >
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
              *ngIf="holidays.length>0"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>

    <app-modal-holiday (holidayData)="createHoliday($event)"></app-modal-holiday>
  `,
  styleUrls: []
})

export class HolidaysComponent {
  @ViewChild('modalHolidays') modalHolidays: any;

  currentView: string = 'holidays';

  profile: any = {};
  permissions: any = {};
  holidays: any = [];
  meta: any = {};
  faPlus = faPlus;
  payload: any = {
    profile_id: 1,
    page: 1,
    per_page: 10,
  };

  faTimes = faTimes;

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private taskService: TasksService,
    private toastr: ToastrService,
    private authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile.id;
  }

  ngOnInit(): void {
    this.loadHolidays(this.payload);
  }

  addHoliday() {
    new bs.Modal(<HTMLInputElement>document.getElementById('modalHolidays')).show();
  }

  loadHolidays(payload: any = {}) {
    this.taskService.getHolidays(payload).subscribe((res: any) => {
      console.log(res);
      this.holidays = res.data;
    });
  }

  createHoliday(event: any) {
    console.log(event);
    console.log('profile => ', this.profile);
    this.payload.holiday = event.fecha;
    this.taskService.createHoliday({
      profile_id: this.profile.id,
      holiday: event.fecha    
    }).subscribe((res: any) => {
      console.log(res);
      this.toastr.success('Día no laboral creado.');
      window.location.reload();
    });
  }

  pageChanged(event: any) {
    this.payload.page = event;    
  }

  deleteHoliday(holiday: any) {
    console.log(holiday);
    this.taskService.deleteHoliday(holiday.id).subscribe((res: any) => {
      console.log(res);
      this.toastr.success('Día no laboral eliminado.');
      window.location.reload();
    });
  }
}
